import React, { useLayoutEffect } from "react";
import { Modal } from "react-bootstrap";
import { CustomProjectModalProps } from "./CustomProjectModal.types.tsx";
import CustomProjectStepOne from "./CustomProjectSteps/CustomProjectStep1.tsx";
import CustomProjectStepTwo from "./CustomProjectSteps/CustomProjectStep2.tsx";

import { useHomeContext } from "../../views/Home/HomeView.context.tsx";

const CustomProjectModal: React.FC<CustomProjectModalProps> = (props) => {
  const { show, handleClose, title, validated } = props;

  const [step, setStep] = React.useState<1 | 2>(1);
  const { isLoading, spinnerLoading } = useHomeContext();

  const anchorRef = React.useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (!anchorRef.current) return;

    const modalBody = anchorRef.current.closest(".modal-body") as HTMLElement | null;

    if (!modalBody) return;

    requestAnimationFrame(() => {
      modalBody.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }, [step]);

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div ref={anchorRef} />

        {isLoading ? (
          spinnerLoading
        ) : (
          <>
            {step === 1 && (
              <CustomProjectStepOne {...props} validated={validated} onNext={() => setStep(2)} />
            )}

            {step === 2 && <CustomProjectStepTwo {...props} onBack={() => setStep(1)} />}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CustomProjectModal;
